{
  "familyId": "TGL-TIJD-DUUR",
  "questions": [
    {
      "id": "TGL-TIJD-DUUR-001",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een leraar begint de les om 09:00 en eindigt om 10:30. Hoe lang duurt de les?",
      "options": ["1 uur en 30 minuten", "1 uur", "2 uur", "30 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Tijdsduur berekenen", "content": "Ga naar het volgende hele uur: 09:00 → 10:00 = 1 uur. Tel de rest: 10:00 → 10:30 = 30 min. Totaal: 1 uur en 30 minuten.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_lesson",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De leraar berekent: 09:00 → 10:00 = 1 uur. Dan 10:00 → 10:30 = 30 minuten. Totaal: 1 uur en 30 minuten.",
        "solutionSteps": ["09:00 → 10:00 = 1 uur", "10:00 → 10:30 = 30 minuten", "Totaal: 1 uur + 30 min = 1 uur en 30 minuten"],
        "distractorExplanations": {
          "0": "Goed! De les duurt 1 uur en 30 minuten.",
          "1": "Je dacht waarschijnlijk dat je alleen het hele uur telt. Maar na 10:00 zijn er nog 30 minuten tot 10:30. Onthoud: tel ook de minuten na het hele uur.",
          "2": "Je dacht waarschijnlijk dat het 2 uur is. Maar van 09:00 tot 10:30 is 1,5 uur, niet 2 uur. Onthoud: reken stap voor stap.",
          "3": "Je dacht waarschijnlijk dat alleen de minuten tellen. Maar je vergeet het hele uur van 09:00 → 10:00. Onthoud: tel eerst de uren, dan de minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-002",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een treinmachinist vertrekt om 13:45 en komt aan om 15:20. Hoe lang duurt de reis?",
      "options": ["1 uur en 35 minuten", "1 uur en 25 minuten", "2 uur en 35 minuten", "1 uur en 45 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "numberline", "data": { "start": 13, "end": 16, "markers": [13.75, 15.33], "label": "Tijdlijn: vertrek (13:45) en aankomst (15:20)" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Tijdsduur over uurgrens", "content": "13:45 → 14:00 = 15 min. 14:00 → 15:00 = 1 uur. 15:00 → 15:20 = 20 min. Totaal: 15 + 60 + 20 = 95 min = 1 uur en 35 min.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_train",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De treinmachinist berekent stap voor stap: 13:45 → 14:00 = 15 minuten. 14:00 → 15:00 = 1 uur. 15:00 → 15:20 = 20 minuten. Totaal: 15 + 60 + 20 = 95 minuten = 1 uur en 35 minuten.",
        "solutionSteps": ["13:45 → 14:00 = 15 min", "14:00 → 15:00 = 60 min", "15:00 → 15:20 = 20 min", "Totaal: 15 + 60 + 20 = 95 min = 1 uur en 35 min"],
        "distractorExplanations": {
          "0": "Goed! De reis duurt 1 uur en 35 minuten.",
          "1": "Je dacht waarschijnlijk dat 13:45 → 14:00 maar 5 minuten is. Maar 60 − 45 = 15 minuten. Onthoud: van :45 naar het hele uur = 15 minuten.",
          "2": "Je dacht waarschijnlijk dat er 2 hele uren tussen zitten. Maar van 13:45 tot 15:20 is iets meer dan 1,5 uur. Onthoud: reken stap voor stap via de uurgrens.",
          "3": "Je dacht waarschijnlijk dat 15 + 20 = 45 minuten. Maar 15 + 20 = 35 minuten. Onthoud: tel de deelminuten nauwkeurig op."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-003",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een sportcoach begint de training om 14:30. De training duurt 90 minuten. Hoe laat is de training afgelopen?",
      "options": ["16:00", "15:30", "16:30", "15:00"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "90 minuten omzetten", "content": "90 minuten = 1 uur en 30 minuten. 14:30 + 1 uur = 15:30, dan + 30 min = 16:00.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_sports",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De sportcoach berekent: 90 minuten = 1 uur en 30 minuten. 14:30 + 1 uur = 15:30. Dan 15:30 + 30 minuten = 16:00.",
        "solutionSteps": ["90 min = 1 uur + 30 min", "14:30 + 1 uur = 15:30", "15:30 + 30 min = 16:00"],
        "distractorExplanations": {
          "0": "Goed! 14:30 + 90 minuten = 16:00.",
          "1": "Je dacht waarschijnlijk dat je alleen 1 uur optelt. Maar 90 minuten = 1 uur én 30 minuten. Na 15:30 moet je nog 30 minuten bijtellen: 16:00. Onthoud: 90 min = 1,5 uur.",
          "2": "Je dacht waarschijnlijk dat 90 minuten = 2 uur. Maar 90 minuten = 1 uur en 30 minuten, niet 2 uur. Onthoud: 1 uur = 60 minuten.",
          "3": "Je dacht waarschijnlijk dat je alleen 30 minuten optelt. Maar 90 minuten = 1 uur én 30 minuten. Je vergeet het hele uur. Onthoud: 90 min = 1,5 uur."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-004",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een kok begint met koken om 16:15 en is klaar om 17:40. Hoe lang kookte de kok?",
      "options": ["1 uur en 25 minuten", "1 uur en 15 minuten", "1 uur en 35 minuten", "2 uur"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stap voor stap rekenen", "content": "16:15 → 17:00 = 45 min. 17:00 → 17:40 = 40 min. Totaal: 45 + 40 = 85 min = 1 uur en 25 min.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_cooking",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De kok berekent: 16:15 → 17:00 = 45 minuten (60 − 15 = 45). Dan 17:00 → 17:40 = 40 minuten. Totaal: 45 + 40 = 85 minuten = 1 uur en 25 minuten.",
        "solutionSteps": ["16:15 → 17:00 = 45 min (60 − 15 = 45)", "17:00 → 17:40 = 40 min", "Totaal: 45 + 40 = 85 min = 1 uur en 25 min"],
        "distractorExplanations": {
          "0": "Goed! De kok kookte 1 uur en 25 minuten.",
          "1": "Je dacht waarschijnlijk dat 16:15 → 17:00 maar 35 minuten is. Maar 60 − 15 = 45 minuten. Onthoud: van :15 naar het hele uur = 45 minuten.",
          "2": "Je dacht waarschijnlijk dat 45 + 40 = 95 minuten. Maar 45 + 40 = 85 minuten = 1 uur en 25 minuten (85 − 60 = 25). Onthoud: tel nauwkeurig op.",
          "3": "Je dacht waarschijnlijk dat het 2 uur is. Maar van 16:15 tot 17:40 is iets meer dan 1 uur, niet 2 uur. Onthoud: reken stap voor stap."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-005",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een filmregisseur start de opnames om 14:00. De opnames duren 1 uur en 45 minuten. Hoe laat zijn de opnames klaar?",
      "options": ["15:45", "15:15", "16:00", "15:30"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Tijd erbij tellen", "content": "14:00 + 1 uur = 15:00. Dan + 45 minuten = 15:45.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_film",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De filmregisseur berekent: 14:00 + 1 uur = 15:00. Dan 15:00 + 45 minuten = 15:45.",
        "solutionSteps": ["14:00 + 1 uur = 15:00", "15:00 + 45 min = 15:45"],
        "distractorExplanations": {
          "0": "Goed! 14:00 + 1 uur en 45 minuten = 15:45.",
          "1": "Je dacht waarschijnlijk dat je 15 minuten optelt. Maar het is 45 minuten, niet 15. Onthoud: lees het aantal minuten goed.",
          "2": "Je dacht waarschijnlijk dat 45 minuten = 1 uur. Maar 45 minuten is geen heel uur. Onthoud: 1 uur = 60 minuten.",
          "3": "Je dacht waarschijnlijk dat 45 minuten = 30 minuten. Maar 45 minuten is een kwartier meer dan een half uur. Onthoud: 45 min = 30 min + 15 min."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-006",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een piloot vraagt: hoeveel dagen heeft februari in een gewoon jaar (geen schrikkeljaar)?",
      "options": ["28", "30", "29", "31"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dagen in februari", "content": "Februari heeft 28 dagen in een gewoon jaar. Alleen in een schrikkeljaar (om de 4 jaar) heeft februari 29 dagen.", "icon": "lightbulb" } }
      ],
      "conceptId": "calendar_days_months",
      "variantIndex": 6,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De piloot weet: februari is de enige maand met minder dan 30 dagen. In een gewoon jaar heeft februari 28 dagen. Alleen in een schrikkeljaar (om de 4 jaar) zijn het er 29.",
        "solutionSteps": ["De meeste maanden hebben 30 of 31 dagen", "Februari is de uitzondering: 28 dagen (gewoon jaar)", "In een schrikkeljaar: 29 dagen", "De vraag gaat over een gewoon jaar → 28 dagen"],
        "distractorExplanations": {
          "0": "Goed! Februari heeft 28 dagen in een gewoon jaar.",
          "1": "Je dacht waarschijnlijk dat februari 30 dagen heeft. Maar 30 dagen hebben april, juni, september en november. Februari is korter: 28 dagen. Onthoud: februari is de kortste maand.",
          "2": "Je dacht waarschijnlijk dat het een schrikkeljaar is. Maar de vraag zegt 'gewoon jaar'. In een gewoon jaar: 28 dagen, in een schrikkeljaar: 29. Onthoud: lees goed of het een schrikkeljaar is.",
          "3": "Je dacht waarschijnlijk dat februari 31 dagen heeft. Maar 31 dagen hebben januari, maart, mei, juli, augustus, oktober en december. Februari heeft 28. Onthoud: februari is de kortste maand."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-007",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "fill_in",
      "question": "Een zwemleraar begint de les om 14:30 en eindigt om 16:15. Hoeveel minuten duurt de zwemles?",
      "options": ["105", "95", "115", "125"],
      "correctAnswer": 0,
      "data": { "acceptableAnswers": ["105"], "placeholder": "Typ het aantal minuten", "caseSensitive": false },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Minuten berekenen", "content": "14:30 → 15:00 = 30 min. 15:00 → 16:00 = 60 min. 16:00 → 16:15 = 15 min. Totaal: 30 + 60 + 15 = 105 min.", "icon": "lightbulb" } }
      ],
      "conceptId": "time_duration_fill_in",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De zwemleraar berekent stap voor stap: 14:30 → 15:00 = 30 minuten. 15:00 → 16:00 = 60 minuten. 16:00 → 16:15 = 15 minuten. Totaal: 30 + 60 + 15 = 105 minuten.",
        "solutionSteps": ["14:30 → 15:00 = 30 min", "15:00 → 16:00 = 60 min", "16:00 → 16:15 = 15 min", "Totaal: 30 + 60 + 15 = 105 min"],
        "distractorExplanations": {
          "0": "Goed! De zwemles duurt 105 minuten.",
          "1": "Je dacht waarschijnlijk dat 14:30 → 15:00 maar 20 minuten is. Maar 60 − 30 = 30 minuten. Onthoud: van :30 naar het hele uur = 30 minuten.",
          "2": "Je dacht waarschijnlijk dat er een stap te veel is. Maar 30 + 60 + 15 = 105, niet 115. Onthoud: tel de drie delen nauwkeurig op.",
          "3": "Je dacht waarschijnlijk dat er een extra stap is. Maar 30 + 60 + 15 = 105, niet 125. Onthoud: controleer elke stap apart."
        }
      }
    }
  ]
}